"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RegEx = exports.domainRegex = exports.subDomainRegex = exports.emailRegex = void 0;
exports.emailRegex = /^[a-zA-Z0-9!#$%&'*+-/=?^_`{|]{1,64}[@]((([a-zA-Z0-9][a-zA-Z0-9-_]*[a-zA-Z0-9])|[a-zA-Z0-9])\.){1,}[a-zA-Z0-9]{2,}$/;
exports.subDomainRegex = /^(([a-zA-Z0-9][a-zA-Z0-9-_]*[a-zA-Z0-9])|[a-zA-Z0-9])$/;
exports.domainRegex = /^((([a-zA-Z0-9][a-zA-Z0-9-_]*[a-zA-Z0-9])|[a-zA-Z0-9])\.){1,}[a-zA-Z0-9]{2,}$/;
exports.RegEx = {
    domainRegex: exports.domainRegex,
    emailRegex: exports.emailRegex,
    subDomainRegex: exports.subDomainRegex,
};
//# sourceMappingURL=regex.js.map